import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Button,
   Box,
   Flex,
   HStack,
   Text,
   Table,
   Thead,
   Tbody,
   Tr,
   Th,
   Td,
   useColorMode,
} from '@chakra-ui/react';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUser } from 'contexts';
import { useNavigate } from 'react-router-dom';

import { getLogs } from '../../redux/actions/logs';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import JsonDifferenceModal from '../../views/admin/report/components/JsonDifferenceModal';

const SalesDetails = ({ isOpen, onClose, title, entityType, id }) => {
   const { user } = useUser();
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const logsData = useSelector((state) => state.logs?.list || []);
   const [showDiffModal, setShowDiffModal] = useState(false);
   const [selectedLog, setSelectedLog] = useState(null);

   const handleClose = () => {
      onClose();
   };

   const handleOpenModel = (logItem) => {
      setSelectedLog(logItem);
      setShowDiffModal(true);
   };

   useEffect(() => {
      if (isOpen && id) {
         const fetchLogs = async () => {
            const transactionType =
               entityType === 'salesin'
                  ? 'sales'
                  : entityType === 'salesrt'
                  ? 'salesReturn'
                  : entityType === 'purchasein'
                  ? 'purchases'
                  : entityType === 'purchasert'
                  ? 'purchaseReturn'
                  : entityType === 'voucher'
                  ? 'voucher'
                  : entityType;

            await dispatch(
               getLogs({
                  tableId: id,
                  transactionTypes: transactionType,
               }),
            );
         };
         fetchLogs();
      }
   }, [isOpen, id, entityType]);

   useEffect(() => {
      const handleKeyDown = (e) => {
         if (e.key === 'Escape') {
            if (!showDiffModal) {
               onClose();
            }
            if (showDiffModal) {
               setShowDiffModal(false);
               setSelectedLog(null);
            }
         }
      };

      window.addEventListener('keydown', handleKeyDown, true);
      return () => {
         window.removeEventListener('keydown', handleKeyDown, true);
      };
   }, [onClose, showDiffModal, setShowDiffModal, setSelectedLog]);

   return (
      <>
         <Modal isOpen={isOpen} onClose={handleClose} size="6xl">
            <ModalOverlay className="backdrop-blur-sm bg-black/30" />
            <ModalContent
               className={`${isDark ? 'bg-gray-800' : 'bg-white'} shadow-2xl border ${
                  isDark ? 'border-gray-700' : 'border-gray-200'
               }`}>
               <ModalHeader
                  className={`${
                     isDark
                        ? 'bg-gradient-to-r from-gray-800 to-gray-900 border-gray-700'
                        : 'bg-gradient-to-r from-blue-50 to-indigo-50 border-gray-200'
                  } border-b`}>
                  <Flex alignItems={'center'} gap={25}>
                     <HStack>
                        <Box>
                           <Text
                              className={`text-3xl font-bold ${
                                 isDark ? 'text-white' : 'text-gray-800'
                              } flex items-center`}>
                              <span
                                 className={`inline-block w-1.5 h-8 ${
                                    isDark ? 'bg-blue-500' : 'bg-blue-600'
                                 } mr-3 rounded-full`}></span>
                              {title}
                           </Text>
                        </Box>
                     </HStack>
                     {/* <PeriodDatePicker
                        value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                        onChange={handleDateRangeChange}
                        defaultPeriod="last7Days"
                        style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                     /> */}
                  </Flex>
               </ModalHeader>
               <ModalCloseButton
                  className={`${
                     isDark
                        ? 'text-gray-300 hover:text-white hover:bg-gray-700'
                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                  } rounded-lg transition-all duration-200`}
               />
               <ModalBody className={`p-6 ${isDark ? 'bg-gray-800' : 'bg-gray-50'}`}>
                  <div
                     className={`rounded-lg overflow-hidden border ${
                        isDark ? 'border-gray-700' : 'border-gray-200'
                     } shadow-lg`}>
                     <Table variant="simple" size="sm">
                        <Thead className={`${isDark ? 'bg-gray-900' : 'bg-gradient-to-r from-gray-100 to-gray-200'}`}>
                           <Tr>
                              <Th
                                 className={`${
                                    isDark ? 'text-gray-300 border-gray-700' : 'text-gray-700 border-gray-300'
                                 } font-semibold tracking-wider uppercase text-xs py-4`}>
                                 Doc No
                              </Th>
                              <Th
                                 className={`${
                                    isDark ? 'text-gray-300 border-gray-700' : 'text-gray-700 border-gray-300'
                                 } font-semibold tracking-wider uppercase text-xs py-4`}>
                                 Log Type
                              </Th>
                              <Th
                                 className={`${
                                    isDark ? 'text-gray-300 border-gray-700' : 'text-gray-700 border-gray-300'
                                 } font-semibold tracking-wider uppercase text-xs py-4`}>
                                 Account Name
                              </Th>
                              <Th
                                 className={`${
                                    isDark ? 'text-gray-300 border-gray-700' : 'text-gray-700 border-gray-300'
                                 } font-semibold tracking-wider uppercase text-xs py-4`}>
                                 Daybook Name
                              </Th>
                              <Th
                                 className={`${
                                    isDark ? 'text-gray-300 border-gray-700' : 'text-gray-700 border-gray-300'
                                 } font-semibold tracking-wider uppercase text-xs py-4`}>
                                 Device Platform
                              </Th>
                              <Th
                                 className={`${
                                    isDark ? 'text-gray-300 border-gray-700' : 'text-gray-700 border-gray-300'
                                 } font-semibold tracking-wider uppercase text-xs py-4`}>
                                 Modified
                              </Th>
                           </Tr>
                        </Thead>
                        <Tbody className={isDark ? 'bg-gray-800' : 'bg-white'}>
                           {logsData
                              ?.sort((a, b) => (a.entryType === 'ADD' ? -1 : 1))
                              .map((log, index) => (
                                 <Tr
                                    key={log.id}
                                    onClick={() => handleOpenModel(log)}
                                    className={`cursor-pointer transition-all duration-200 ${
                                       isDark ? 'hover:bg-gray-700 border-gray-700' : 'hover:bg-blue-50 border-gray-200'
                                    } ${
                                       index % 2 === 0
                                          ? isDark
                                             ? 'bg-gray-800'
                                             : 'bg-white'
                                          : isDark
                                          ? 'bg-gray-850'
                                          : 'bg-gray-50'
                                    }`}>
                                    <Td
                                       className={`${
                                          isDark ? 'text-gray-300 border-gray-700' : 'text-gray-700 border-gray-200'
                                       } py-4 font-medium`}>
                                       {entityType === 'voucher'
                                          ? log.entryType === 'ADD'
                                             ? log.newJson?.docNumber
                                             : `${log.newJson?.docNumber || ''}`
                                          : log.entryType === 'ADD'
                                          ? log.newJson?.docno
                                          : `${log.newJson?.docno || ''}`}
                                    </Td>
                                    <Td className={`${isDark ? 'border-gray-700' : 'border-gray-200'} py-4`}>
                                       <span
                                          className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold ${
                                             log.entryType === 'ADD'
                                                ? isDark
                                                   ? 'bg-green-900 text-green-300'
                                                   : 'bg-green-100 text-green-800'
                                                : log.entryType === 'UPDATE'
                                                ? isDark
                                                   ? 'bg-blue-900 text-blue-300'
                                                   : 'bg-blue-100 text-blue-800'
                                                : isDark
                                                ? 'bg-red-900 text-red-300'
                                                : 'bg-red-100 text-red-800'
                                          }`}>
                                          {log.entryType}
                                       </span>
                                    </Td>
                                    <Td
                                       className={`${
                                          isDark ? 'text-gray-300 border-gray-700' : 'text-gray-700 border-gray-200'
                                       } py-4`}>
                                       {entityType === 'voucher'
                                          ? log.entryType === 'ADD'
                                             ? log.newJson?.accountName
                                             : `${log.newJson?.accountName || ''}`
                                          : log.entryType === 'ADD'
                                          ? log.newJson?.accountname
                                          : `${log.newJson?.accountname || ''}`}
                                    </Td>
                                    <Td
                                       className={`${
                                          isDark ? 'text-gray-300 border-gray-700' : 'text-gray-700 border-gray-200'
                                       } py-4`}>
                                       {entityType === 'voucher'
                                          ? log.entryType === 'ADD'
                                             ? log.newJson?.daybookName
                                             : `${log.newJson?.daybookName || ''}`
                                          : log.entryType === 'ADD'
                                          ? log.newJson?.daybookname
                                          : `${log.newJson?.daybookname || ''}`}
                                    </Td>
                                    <Td
                                       className={`${
                                          isDark ? 'text-gray-300 border-gray-700' : 'text-gray-700 border-gray-200'
                                       } py-4`}>
                                       <span
                                          className={`inline-flex items-center ${
                                             isDark ? 'text-gray-400' : 'text-gray-600'
                                          }`}>
                                          {log.devicePlatform ? log.devicePlatform : '—'}
                                       </span>
                                    </Td>
                                    <Td
                                       className={`${
                                          isDark ? 'text-gray-400 border-gray-700' : 'text-gray-600 border-gray-200'
                                       } py-4 text-sm`}>
                                       {log.entryType === 'ADD'
                                          ? new Date(log.createdAt).toLocaleString()
                                          : new Date(log.createdAt).toLocaleString() || ''}
                                    </Td>
                                 </Tr>
                              ))}
                        </Tbody>
                     </Table>
                  </div>
                  {logsData?.length === 0 && (
                     <div className={`text-center py-12 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                        <svg
                           className="mx-auto h-12 w-12 mb-4 opacity-50"
                           fill="none"
                           viewBox="0 0 24 24"
                           stroke="currentColor">
                           <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                           />
                        </svg>
                        <p className="text-lg font-medium">No logs found</p>
                     </div>
                  )}
               </ModalBody>

               <ModalFooter
                  className={`${isDark ? 'bg-gray-800 border-gray-700' : 'bg-gray-50 border-gray-200'} border-t`}>
                  <Button
                     colorScheme="blue"
                     mr={3}
                     onClick={onClose}
                     className={`${
                        isDark ? 'bg-blue-600 hover:bg-blue-700' : 'bg-blue-500 hover:bg-blue-600'
                     } text-white px-6 py-2 rounded-lg font-medium transition-all duration-200 shadow-md hover:shadow-lg`}>
                     Close
                  </Button>
               </ModalFooter>
               {showDiffModal && selectedLog && (
                  <JsonDifferenceModal
                     logData={selectedLog}
                     isOpen={showDiffModal}
                     onClose={() => {
                        setShowDiffModal(false);
                        setSelectedLog(null);
                     }}
                  />
               )}
            </ModalContent>
         </Modal>
      </>
   );
};

export default SalesDetails;
